import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	cannotLoadUsers: {
		id: 'business-list.list-view.user-cell.error-user.cannot-load-users',
		defaultMessage: 'Couldn’t find users.',
		description: 'Error message that indicates that users could not be loaded',
	},
	tryAgain: {
		id: 'business-list.list-view.user-cell.error-user.try-again',
		defaultMessage: 'Try again',
		description: 'Subtle link to reload user fetching',
	},
});
